import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5eb617dc&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5eb617dc&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=5eb617dc&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb617dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5eb617dc')) {
      api.createRecord('5eb617dc', component.options)
    } else {
      api.reload('5eb617dc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5eb617dc&scoped=true&lang=pug", function () {
      api.rerender('5eb617dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/parentPage/addChildrenModal/index.vue"
export default component.exports